<img
  class="hover-trigger rounded"
  [src]="src"
  [alt]="alt"
  [width]="thumbnailWidth"
  [height]="thumbnailHeight"
  [mtxTooltip]="tooltipTpl"
  [mtxTooltipClass]="'thumnail-tooltip-img-9b5e-6745cfdb8b6e'" />

<ng-template #tooltipTpl>
  <img
    [src]="fullSizeSrc ?? src" />
</ng-template>
